{
  "title": "Dashboard",
  "canvas": "Project map",
  "empty": "Nothing to draw yet",
  "emptyLead": "The map shows the project's servers, public IPs, firewalls and networks once there are some. Create a server to start.",
  "arrange": "Arrange",
  "arrangeTitle": "Arrange the whole map?",
  "arrangeLead": "Every object is placed anew: the Internet on the left, in each location the public IPs and firewalls, then the servers; the networks on the right. Positions you and others have set are replaced for everyone in the project.",
  "arrangeConfirm": "Arrange",
  "arrangeSelected": "Arrange selected ({{count}})",
  "arrangeSelectedTitle": "Arrange the selected objects ({{count}})?",
  "arrangeSelectedLead": "The selected objects are put in order where they are now; everything else stays where it is. Esc clears the selection.",
  "readOnlyNote": "Viewing only on a small screen: move, zoom and select; change objects on their pages.",
  "viewerNote": "You are a guest here: you can view the map; its owners and administrators arrange it.",
  "saveFailed": "The new position could not be saved",
  "zoomIn": "Zoom in",
  "zoomOut": "Zoom out",
  "fit": "Show everything",
  "minimap": "Overview of the map",
  "legend": {
    "label": "Line colours",
    "public": "Public access",
    "firewall": "Firewall",
    "private": "Private network",
    "balancer": "Load balancer to its targets"
  },
  "a11y": {
    "node": "Press Enter to select, arrow keys to move the selected object.",
    "nodeReadOnly": "Press Enter to select and see the details.",
    "moved": "Moved {{direction}}, now at {{x}}, {{y}}",
    "edge": "Connection",
    "handle": "Connection point"
  },
  "kinds": {
    "internet": "Internet",
    "server": "Server",
    "public_ip": "Public IP",
    "firewall": "Firewall",
    "network": "Network",
    "volume": "Volume",
    "floating_ip": "Floating IP",
    "load_balancer": "Load balancer"
  },
  "internet": {
    "title": "Internet",
    "lead": "Public traffic",
    "about": "Where public traffic comes from. Its lines show which ports of each server are open to it, from the firewalls applied to the server."
  },
  "server": {
    "cores": "{{count}}\u00a0vCPU",
    "noImage": "Image deleted",
    "terminal": "Terminal on {{name}}",
    "wan": "WAN",
    "noPublic": "No public address",
    "noFirewall": "No firewall",
    "firewalls": "Firewalls: {{names}}",
    "parts": "What belongs to the server",
    "disks": "Disks",
    "noDisks": "None attached"
  },
  "chips": {
    "disk": "{{size}}\u00a0GB · local NVMe",
    "volume": "{{size}}\u00a0GB · {{format}}",
    "volumeRaw": "{{size}}\u00a0GB · not formatted",
    "backupsOff": "Backups off",
    "backupsWindow": "Backups · window {{window}}",
    "backupsCopies": "Backups: {{count}} · last {{last}}",
    "backupsNone": "Backups on · no copy yet",
    "snapshots": "Snapshots: {{count}} · {{size}}\u00a0GB · last {{last}}",
    "iso": "ISO {{name}}",
    "rescue": "Rescue on",
    "protected": "Protected",
    "rebuildProtected": "Rebuild locked",
    "busy": "Busy",
    "placement": "Spread: {{name}}",
    "package": "{{name}}",
    "packageDrift": "{{name}} · changed by hand"
  },
  "metrics": {
    "label": "Load over the last 30 minutes",
    "cpu": "CPU",
    "network": "Network",
    "disk": "Disk IOPS",
    "iops": "r {{read}} · w {{write}}",
    "off": "No metrics while the server is not running.",
    "error": "Metrics are not available right now.",
    "autopilot": "Autopilot: memory and disk usage",
    "memory": "Memory",
    "diskUsage": "Disk"
  },
  "ports": {
    "all": "all ports open",
    "none": "closed"
  },
  "ip": {
    "assigned": "on {{server}}",
    "free": "Not assigned",
    "unreachable": "Not reachable: assigned to no server"
  },
  "firewall": {
    "rules": "Rules: {{inbound}} in · {{outbound}} out",
    "servers": "Servers: {{count}}",
    "unused": "Applied to nothing"
  },
  "network": {
    "zone": "Zone {{zone}}",
    "subnets": "Subnets: {{count}}",
    "servers": "servers: {{count}}"
  },
  "panel": {
    "label": "Selected object",
    "close": "Close details",
    "status": "Status",
    "type": "Type",
    "location": "Location",
    "image": "System",
    "public": "Public addresses",
    "ports": "Open to the Internet",
    "firewalls": "Firewalls",
    "networks": "Networks",
    "address": "Address",
    "family": "Family",
    "server": "Server",
    "reverseDns": "Reverse DNS",
    "rules": "Rules",
    "appliedTo": "Applied to",
    "selectors": "Label selectors",
    "range": "IP range",
    "subnets": "Subnets",
    "attached": "Servers",
    "routes": "Routes",
    "about": "What it is",
    "cost": "This object per month",
    "free": "Free",
    "total": "Whole project per month",
    "costNote": "Net of VAT, from the price list; traffic above the included amount and snapshots are not counted.",
    "links": "Where to change it",
    "openServer": "Open the server",
    "power": "Power",
    "networking": "Addresses and networks",
    "metrics": "Load charts",
    "openIps": "Open IP addresses",
    "openAssigned": "Open {{server}}",
    "editRules": "Edit rules",
    "applyFirewall": "Servers and selectors",
    "openNetwork": "Open the network",
    "subnetsLink": "Subnets",
    "size": "Size",
    "fileSystem": "File system",
    "device": "Device",
    "openVolumes": "Open volumes",
    "openFloatingIps": "Open floating IPs",
    "openLoadBalancer": "Open the load balancer",
    "description": "Description",
    "placement": "Placement group"
  },
  "busy": "Change in progress",
  "connect": {
    "hint": "Drag a line from a point on a card to a matching point: only the ones that fit light up. A free volume connects to a server's \"Disks\" point, a floating IP to its WAN point. Select a line or a volume on a server to remove the connection. Shift + click or a Shift + drag box selects several objects.",
    "slot": "Network",
    "refused": "This cannot be connected here",
    "point": {
      "wan": "WAN point: {{name}}",
      "slot": "Connect to a network: {{name}}",
      "joined": "{{name}} in network {{network}}",
      "ip": "Public IP: {{name}}",
      "network": "Network inlet: {{name}}",
      "firewall": "Apply firewall: {{name}}",
      "fixed": "Connection point",
      "disk": "Server disks: {{name}}",
      "volume": "Volume point: {{name}}",
      "floating": "Floating IP: {{name}}"
    },
    "accepts": {
      "ip": "A public or floating IP connects only to a server's WAN point.",
      "wan": "A WAN point takes a public or floating IP or a firewall.",
      "slot": "A server's free point (\"+ Network\") connects to a network's inlet.",
      "network": "A network takes a server's free point (\"+ Network\").",
      "firewall": "A firewall connects only to a server's WAN point.",
      "volume": "A free volume connects to a server's \"Disks\" point.",
      "disk": "A \"Disks\" point takes a free volume."
    },
    "reasons": {
      "same_object": "This is a point of the same object.",
      "wrong_point": "These points cannot be joined.",
      "fixed_point": "This point only shows existing connections.",
      "already_connected": "They are already connected.",
      "ip_assigned": "The IP is already assigned to {{server}}. Unassign it there first.",
      "ip_blocked": "The provider blocked this IP: it cannot be assigned.",
      "other_location": "The IP is in {{ip}}, the server in {{server}}. A public IP goes only to a server of its own location.",
      "server_has_address": "The server already has {{family}} {{address}}: one address of each kind per server. Unassign it first.",
      "server_busy": "{{server}} is busy: running another action or changing state.",
      "network_limit": "The server is already in {{max}} networks, the most it can have.",
      "network_zone": "The network has no subnet in the server's network zone ({{zone}}). Add one on the network's page.",
      "firewall_limit": "{{max}} firewalls already apply to the server, the most it can have.",
      "volume_attached": "The volume is attached to {{server}}. Detach it there first.",
      "volume_creating": "Volume {{volume}} is still being created.",
      "volume_location": "The volume is in {{volume}}, the server in {{server}}. A volume attaches only to a server of its location.",
      "volume_limit": "The server already has {{max}} volumes, the most it can take.",
      "floating_zone": "The floating IP is in network zone {{ip}}, the server in {{server}}. It points only at servers of its zone.",
      "resource_busy": "{{name}}: another change is running. Wait for it to finish."
    },
    "volumeChip": "Volume {{name}} ({{size}}) on {{server}}"
  },
  "power": {
    "assignWarning": "Hetzner assigns a public IP only to a stopped server. {{server}} is running: it stops first, then gets the IP. While it is off, its services are down.",
    "unassignWarning": "Hetzner unassigns a public IP only from a stopped server. {{server}} is running: it stops first. While it is off, its services are down.",
    "keepOpen": "The steps run one after another while the dashboard is open: keep the page open until they finish.",
    "legend": "How to stop {{server}}",
    "shutdown": "Shut down gracefully",
    "shutdownHint": "The system gets an ACPI signal and stops by itself; we wait up to 3 minutes.",
    "powerOff": "Cut the power at once",
    "powerOffHint": "Like pulling the plug: unsaved data may be lost.",
    "powerOnAfter": "Start the server again when done"
  },
  "assign": {
    "title": "Assign {{address}} to {{server}}",
    "lead": "The address will lead to this server. The server's firewalls decide which ports are open.",
    "submit": "Assign",
    "submitCycle": "Stop, assign and start",
    "submitOff": "Stop and assign"
  },
  "attach": {
    "title": "Connect {{server}} to network {{network}}",
    "lead": "The server gets a private address in a subnet of its network zone ({{zone}}).",
    "subnets": "Subnets of the zone",
    "address": "Private address",
    "auto": "Automatic",
    "autoHint": "The provider picks a free address.",
    "fixed": "Choose the address",
    "ip": "The server's address in the network",
    "ipHint": "For example {{example}}, the first free one.",
    "alias": "Extra addresses (alias IPs)",
    "aliasHint": "Optional. Up to {{max}} addresses, comma separated, in the same subnets.",
    "submit": "Connect",
    "problems": {
      "invalid": "This is not an IPv4 address.",
      "outside": "The address is outside the subnets of zone {{zone}}.",
      "reserved": "This is the subnet's network, router or broadcast address.",
      "taken": "This address is already in use in the network.",
      "duplicate": "The address is given twice.",
      "tooMany": "At most {{max}} extra addresses."
    }
  },
  "apply": {
    "title": "Apply firewall {{firewall}}",
    "lead": "Inbound rules: {{inbound}}. Everything they do not allow is dropped.",
    "target": "Apply to",
    "server": "Only server {{server}}",
    "serverHint": "The firewall filters this server's inbound traffic.",
    "selector": "Servers by a label selector",
    "selectorHint": "Applies to every server with these labels, new ones too.",
    "selectorField": "Label selector",
    "suggestions": "The server's labels:",
    "matches": "Matching now: {{names}}",
    "matchesNone": "No server matches now.",
    "invalid": "The selector cannot be read: for example role=web or env in (prod,staging).",
    "viaSelector": "The firewall already reaches this server through selector {{selector}}. Applying it directly keeps it there even if the server's labels change.",
    "noPublic": "The server has no public address: the rules have nothing to filter yet.",
    "submit": "Apply"
  },
  "disconnect": {
    "unassign": {
      "title": "Unassign {{address}} from {{server}}?",
      "action": "Unassign IP",
      "actionCycle": "Stop and unassign IP",
      "loses": "{{server}} stops answering on {{address}}.",
      "keeps": "The IP stays in the project, free, and is billed until you delete it."
    },
    "detach": {
      "title": "Detach {{server}} from network {{network}}?",
      "action": "Detach",
      "loses": "{{server}} loses its private address {{ip}}.",
      "traffic": "Private traffic with the other servers of {{network}} stops."
    },
    "remove": {
      "title": "Remove firewall {{firewall}} from {{server}}?",
      "action": "Remove firewall",
      "rules": "The rules of {{firewall}} no longer apply to {{server}}.",
      "open": "{{server}} is left without any firewall: all ports are open."
    },
    "selector": {
      "title": "Remove selector {{selector}} from {{firewall}}?",
      "action": "Remove selector",
      "servers": "The firewall stops applying to every matching server ({{count}}): {{names}}.",
      "future": "New servers with these labels will not get it either."
    },
    "unassignFloating": {
      "keeps": "The address stays in the project, free, and is billed until you delete it. The server keeps running."
    }
  },
  "edge": {
    "label": "Connection: {{from}} → {{to}}",
    "toolbar": "Selected connection",
    "remove": "Remove connection",
    "dismiss": "Dismiss",
    "close": "Deselect",
    "failed": "Failed: {{error}}"
  },
  "steps": {
    "shutdown": "Shutting down {{server}}",
    "power-off": "Powering off {{server}}",
    "power-on": "Starting {{server}}",
    "assign-ip": "Assigning {{address}}",
    "unassign-ip": "Unassigning {{address}}",
    "attach": "Connecting {{server}} to the network",
    "detach": "Detaching {{server}} from the network",
    "apply-firewall": "Applying {{firewall}}",
    "remove-firewall": "Removing {{firewall}}",
    "one": "{{step}} · {{percent}}%",
    "of": "Step {{n}} of {{count}}: {{step}} · {{percent}}%",
    "attach-volume": "Attaching {{volume}} to {{server}}",
    "detach-volume": "Detaching {{volume}} from {{server}}",
    "assign-floating": "Pointing {{address}} at {{server}}",
    "unassign-floating": "Unassigning {{address}}"
  },
  "run": {
    "failed": "The provider did not complete the action.",
    "notStopped": "The server did not stop within 3 minutes.",
    "restarted": "The server was started again.",
    "assigned": "{{address}} assigned to {{server}}",
    "unassigned": "{{address}} unassigned from {{server}}",
    "attached": "{{server}} connected to network {{network}}",
    "detached": "{{server}} detached from network {{network}}",
    "applied": "Firewall {{firewall}} applied: {{target}}",
    "removed": "Firewall {{firewall}} removed: {{target}}",
    "attachedVolume": "Volume {{volume}} attached to {{server}}",
    "detachedVolume": "Volume {{volume}} detached from {{server}}"
  },
  "palette": {
    "title": "Create",
    "label": "Create an object on the map",
    "hint": "Choose one and click the map where to put it, or drag it onto the map.",
    "armed": "Click the map where to put: {{kind}}. Esc cancels.",
    "server": "Server",
    "network": "Network",
    "firewall": "Firewall",
    "public_ip": "Public IP",
    "floating_ip": "Floating IP",
    "volume": "Volume"
  },
  "createMenu": {
    "label": "Create and connect",
    "public_ip": "New public {{family}}",
    "firewall": "New firewall for {{server}}",
    "network": "New network for {{server}}",
    "serverInNetwork": "New server in network {{network}}",
    "serverWithFirewall": "New server with firewall {{firewall}}",
    "floating_ip": "New floating IP for {{server}}",
    "volume": "New volume for {{server}}"
  },
  "create": {
    "pending": "Creating…",
    "failed": "Not created",
    "created": "{{name}} created",
    "network": {
      "title": "New network",
      "lead": "A private network with its first subnet. Connect servers to it with lines from their \"+ Network\" point.",
      "leadConnect": "A private network with its first subnet; {{server}} joins it right after it is created.",
      "zoneFixed": "Network zone: {{zone}}, the same as {{server}}.",
      "submit": "Create network",
      "submitConnect": "Create and connect"
    },
    "firewall": {
      "title": "New firewall",
      "lead": "Rules allow inbound traffic; everything else is dropped.",
      "defaults": "Standard inbound rules: SSH (22/tcp) and ICMP from anywhere",
      "defaultsHint": "Add more rules on the firewall's page.",
      "noRules": "Without rules the firewall closes all inbound traffic.",
      "applyTo": "The firewall applies to {{server}} right away.",
      "fullForm": "Full form with rules",
      "submit": "Create firewall",
      "submitConnect": "Create and apply"
    },
    "public_ip": {
      "title": "New public IP",
      "lead": "An address in the chosen location; assign it to a server with a line to its WAN point.",
      "leadAssign": "The address is created in the location of {{server}} and assigned to it.",
      "family": "Kind: {{family}}",
      "regionFixed": "Location: {{region}}, the same as {{server}}.",
      "submit": "Create IP",
      "submitAssign": "Create and assign"
    },
    "volume": {
      "title": "New volume",
      "lead": "A free volume in the chosen location; attach it with a line to a server's \"Disks\" point.",
      "leadAttach": "The volume is created in {{server}}'s location and attached to it right away.",
      "regionFixed": "Location: {{region}}, the same as {{server}}.",
      "submit": "Create volume",
      "submitAttach": "Create and attach",
      "createdOn": "Volume {{name}} is being created on {{server}}"
    },
    "floating_ip": {
      "title": "New floating IP",
      "lead": "The address is at home in the chosen location; point it at a server of its zone with a line to the WAN point.",
      "leadAssign": "The address is created in {{server}}'s location and pointed at it right away.",
      "regionFixed": "Home location: {{region}}, the same as {{server}}.",
      "submit": "Create IP",
      "submitAssign": "Create and assign"
    }
  },
  "volume": {
    "detached": "Not attached",
    "creating": "Being created"
  },
  "floating": {
    "badge": "Floating"
  },
  "attachVolume": {
    "title": "Attach {{volume}} to {{server}}",
    "lead": "The server sees the volume as {{device}}. The server keeps running.",
    "size": "Size",
    "noFs": "The volume has no file system: create one on the server (mkfs.ext4, for example) and mount it yourself.",
    "submit": "Attach"
  },
  "assignFloating": {
    "title": "Point {{address}} at {{server}}",
    "moveTitle": "Move {{address}} from {{from}} to {{server}}",
    "lead": "Any server of network zone {{zone}} will do, running or not: the server is not stopped and the switch takes seconds.",
    "home": "Home location",
    "leaves": "{{from}} stops getting traffic for {{address}} as soon as the address moves to {{server}}.",
    "submit": "Assign",
    "move": "Move"
  },
  "volumeBar": {
    "toolbar": "Selected volume",
    "label": "Volume {{volume}} on {{server}}",
    "detach": "Detach volume"
  },
  "appliance": {
    "label": "Appliance · {{name}}",
    "title": "The managed appliance of the app «{{name}}»",
    "drift": "changed at the provider",
    "row": "Managed appliance",
    "open": "Open «{{name}}»"
  }
}
